import { GetStaticPropsResult } from 'next'
import React, { ReactElement } from 'react'
import { PageMeta } from 'src/pages'
import { Layout } from '@/components/Layout'
import { Cinemas, CinemasProps } from '@/components/patterns/Cinemas'
import cinemasPageData from '@/content/cinemas.json'
import { HeroImage, HeroImageProps } from '@/components/patterns/HeroImage'
import { getCinemas } from '@/src/cinemas'
import { Container } from '@/components/utils'
import { SectionTitle } from '@/components/elements/SectionTitle'
import homeData from '@/content/home.json'
import {
  NewsletterSection,
  NewsletterSectionProps,
} from '@/components/patterns/NewsletterSection'

interface CinemasPageProps {
  meta: PageMeta
  heroImage: HeroImageProps
  cinemas: CinemasProps
  newsletter: NewsletterSectionProps
}

export async function getStaticProps(): Promise<
  GetStaticPropsResult<CinemasPageProps>
> {
  const cinemas = await getCinemas()
  const provinces = ['Barcelona', 'Girona', 'Lleida', 'Tarragona']

  const cinemasByProvince = []
  provinces.forEach((provinceName) => {
    const province = {
      id: provinceName.toLowerCase(),
      title: provinceName,
      items: cinemas
        .filter((cinema) => cinema.province === provinceName)
        .map((item) => {
          return {
            id: item.id,
            name: item.name,
            city: item.city,
          }
        }),
    }
    cinemasByProvince.push(province)
  })

  return {
    props: {
      meta: {
        title: cinemasPageData.title,
        description: cinemasPageData.subtitle,
      },
      heroImage: {
        picture: cinemasPageData.picture,
      },
      cinemas: {
        cinemas: cinemasByProvince,
      },
      newsletter: homeData.newsletter,
    },
  }
}

export default function CinemasPage({
  meta,
  heroImage,
  cinemas,
  newsletter,
}: CinemasPageProps): ReactElement {
  return (
    <Layout meta={meta}>
      <HeroImage {...heroImage} />
      <Container narrow className="mb-14 mt-10 md:mb-24 md:mt-20">
        <SectionTitle title={meta.title} subtitle={meta.description} />
        <Cinemas {...cinemas} />
      </Container>
      <NewsletterSection {...newsletter} />
    </Layout>
  )
}
